import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { LaborSetupJobRule } from 'src/app/shared/models/laborScheduling/LaborSetup.item';

@Component({
	selector: 'app-employee-scheduling-setup-job-rule',
	templateUrl: './employee-scheduling-setup-job-rule.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeSchedulingSetupJobRuleComponent implements OnInit, OnDestroy {
	@Input() jobRule: LaborSetupJobRule;
	@Output() jobRuleChange = new EventEmitter<LaborSetupJobRule>();

	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Output() jobRuleDeleteChange = new EventEmitter<LaborSetupJobRule>();

	minimizeView = true;

	subscription: Subscription;

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	ngOnInit(): void {
		if (this.venueService.jobList.value.length > 0) {
			this.subscription = new Subscription();
			this.subscription.add(
				this.venueService.jobList.subscribe((data) => {
					this.jobRule.jobName = data.find((i) => i.id === this.jobRule.jobId).name;
				})
			);
		}
		this.minimizeView = !this.jobRule.newJobRule;
		this.jobRule.jobName = this.venueService.jobList.value?.find((i) => i.id === this.jobRule.jobId).name;
	}

	changesToSave() {
		this.changesToSaveChange.emit(true);
	}

	jobRuleDelete() {
		this.jobRuleDeleteChange.emit(this.jobRule);
	}
}
